// @flow

import React from 'react';

import {Typography, makeStyles} from '@material-ui/core';
import {ShoppingCartOutlined} from '@material-ui/icons';
import {commaFormat} from '../../../utils/number';
import {useStoreCurrency} from '../../currency/utils';
import CustomModal from '../../../elements/CustomModal/CustomModal';

import type {ProductBulkPrice} from '../../../entities';
import type {Theme} from '@material-ui/core';
import {colors} from '../../../assets/styles/colors';

type Props = {
  open: boolean,
  handleClose?: () => void,
  bulkPrices: ProductBulkPrice[],
  taxFactor: number,
};

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '24px',
    margin: theme.spacing(2, 0),
  },
  bulkPriceTable: {
    alignSelf: 'center',
    background: colors.grey200,
    padding: theme.spacing(2),
    borderRadius: '16px',
    marginBottom: theme.spacing(3),
  },
  bulkPricesTitle: {
    display: 'flex',
    alignItems: 'center',
  },
  bulkPricesTitleIcon: {
    marginRight: theme.spacing(1),
  },
  bulkPricesTitleText: {
    fontWeight: 600,
    color: colors.grey700,
  },
  bulkPricesTableLines: {
    borderRadius: '8px',
    marginTop: theme.spacing(2),
    background: 'white',
    width: '100%',
  },
  bulkPricesTableLineHead: {
    textAlign: 'left',
    padding: '8px 16px',
    fontWeight: 500,
  },
  bulkPricesTableLineData: {
    borderTop: `1px solid ${colors.grey300}`,
    textAlign: 'left',
    padding: '8px 16px',
    fontWeight: 500,
  },
}));

export default function BulkPriceModal({
  bulkPrices,
  open,
  handleClose,
  taxFactor,
}: Props) {
  const classes = useStyles();
  const currency = useStoreCurrency();
  return (
    <CustomModal open={open} handleCloseModal={handleClose}>
      <Typography className={classes.title}>
        Tabla de precios al por mayor
      </Typography>
      <div className={classes.bulkPriceTable}>
        <div className={classes.bulkPricesTitle}>
          <ShoppingCartOutlined
            className={classes.bulkPricesTitleIcon}
            color="primary"
          />
          <Typography className={classes.bulkPricesTitleText}>
            Precios al por mayor
          </Typography>
        </div>
        <table className={classes.bulkPricesTableLines}>
          <thead>
            <tr>
              <th className={classes.bulkPricesTableLineHead}>Cantidad</th>
              <th className={classes.bulkPricesTableLineHead}>
                Precio por producto
              </th>
            </tr>
          </thead>
          <tbody>
            {bulkPrices.map((element, index) => (
              <tr key={`bp-${index}`}>
                <td className={classes.bulkPricesTableLineData}>
                  A partir de {element.minQuantity} unidades
                </td>
                <td className={classes.bulkPricesTableLineData}>
                  {commaFormat(
                    parseFloat(element.unitPrice),
                    currency ? currency.symbol : ''
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </CustomModal>
  );
}
